import { MouseEventHandler, ReactNode } from "react";

import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  CloseButton,
  StyleProps
} from "@/storybook-components";

interface AlertsPops extends StyleProps {
  title?: string | ReactNode;
  description?: string | ReactNode;
  onClose?: MouseEventHandler<HTMLButtonElement>;
  status: "warning" | "success" | "error" | "info";
}

const Alerts = ({
  title,
  status,
  onClose,
  description,
  ...rest
}: AlertsPops) => {
  return (
    <Alert status={status} {...rest}>
      <AlertIcon />
      <Box>
        {title && <AlertTitle>{title}</AlertTitle>}
        {description && <AlertDescription>{description}</AlertDescription>}
      </Box>
      {onClose && <CloseButton ml="auto" onClick={onClose} />}
    </Alert>
  );
};

export default Alerts;
